module.exports = __webpack_public_path__ + "static/media/tb.c62fb439.png";